import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { HolidayActionTypes } from "./Holiday.type";

export function* fetchAllHolidays(action: any): any {
  try {
    let query = "";
    if (action.payload) {
      query =
        "?" +
        Object.keys(action.payload)
          .map((key) => `${key}=${action.payload[key]}`)
          .join("&");
    }

    const response = yield axios.get(`${API_BASE_URI}/holiday${query}`);
    yield put({
      type: HolidayActionTypes.FETCH_ALL_HOLIDAY_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: HolidayActionTypes.FETCH_ALL_HOLIDAY_FAILURE,
      payload: error,
    });
  }
}

export function* fetchOneHolidays(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/holiday/${action.payload}`
    );
    yield put({
      type: HolidayActionTypes.FETCH_ONE_HOLIDAY_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: HolidayActionTypes.FETCH_ONE_HOLIDAY_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllHolidays() {
  yield takeLatest(HolidayActionTypes.FETCH_ALL_HOLIDAY, fetchAllHolidays);
}

export function* watcherFetchOneHolidays() {
  yield takeLatest(HolidayActionTypes.FETCH_ONE_HOLIDAY, fetchOneHolidays);
}
